import ProfilePage from "../components/ProfilePage.vue";

const userRoutes = [
    {
        path: '/profile',
        component: ProfilePage,
        name: 'profile'
    }
];

export default userRoutes
